import { FC } from 'react'
import { useGetPublicTenantSettingsQuery, useHTMLDirectionSet } from 'react-common'
import { Outlet } from 'react-router-dom'
import { PublicStencilPreset } from '@/features/stencil/PublicStencilPreset/PublicStencilPreset'

export type PublicLayoutMainProps = {
  hideMenu?: boolean
  logoUrl?: string
}

export const PublicLayoutMain: FC<PublicLayoutMainProps> = ({ hideMenu, logoUrl }) => {
  useGetPublicTenantSettingsQuery()
  useHTMLDirectionSet()

  return (
    <PublicStencilPreset hideMenu={hideMenu} logoUrl={logoUrl}>
      <Outlet />
    </PublicStencilPreset>
  )
}
